(() => {
  const initialisePurchaseOptions = (root = document) => {
    root.querySelectorAll('.mah-purchase-options').forEach((fieldset) => {
      if (fieldset.dataset.mahReady === 'true') return;
      fieldset.dataset.mahReady = 'true';
      const hiddenPlan = fieldset.querySelector('[data-mah-selling-plan]');
      const radios = fieldset.querySelectorAll('input[type="radio"][data-mah-plan]');
      const sync = (radio) => {
        fieldset.querySelectorAll('.mah-purchase-card').forEach((card) => card.classList.remove('is-selected'));
        radio.closest('.mah-purchase-card')?.classList.add('is-selected');
        if (!hiddenPlan) return;
        const stickyPlan = document.querySelector('[data-mah-sticky-selling-plan]');
        if (radio.dataset.mahPlan) {
          hiddenPlan.disabled = false;
          hiddenPlan.value = radio.dataset.mahPlan;
          if (stickyPlan) { stickyPlan.disabled = false; stickyPlan.value = radio.dataset.mahPlan; }
        } else {
          hiddenPlan.value = '';
          hiddenPlan.disabled = true;
          if (stickyPlan) { stickyPlan.value = ''; stickyPlan.disabled = true; }
        }
      };
      radios.forEach((radio) => radio.addEventListener('change', () => sync(radio)));
      const checked = fieldset.querySelector('input[type="radio"]:checked');
      if (checked) sync(checked);
    });
  };

  const removeContradictoryCommerceMessages = (root = document) => {
    root.querySelectorAll('.notify__me--available').forEach((wrapper) => {
      const addButton = document.querySelector('.product-form__submit');
      if (addButton && !addButton.disabled) wrapper.hidden = true;
    });
  };

  document.addEventListener('DOMContentLoaded', () => {
    initialisePurchaseOptions();
    removeContradictoryCommerceMessages();
  });

  document.addEventListener('shopify:section:load', (event) => initialisePurchaseOptions(event.target));
  document.addEventListener('mah:purchase-options-updated', () => initialisePurchaseOptions());

})();
